"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.909 12a8.91 8.91 0 11-17.818 0 8.91 8.91 0 0117.818 0zm2 0c0 6.025-4.884 10.91-10.91 10.91-6.024 0-10.908-4.885-10.908-10.91S5.975 1.09 12 1.09 22.909 5.976 22.909 12zm-11.838 3.98l6.545-6.546-1.414-1.414-5.839 5.838-2.565-2.565-1.414 1.414 3.272 3.273.707.707.708-.707z" }), "InWishlist");
//# sourceMappingURL=InWishlist.js.map